import { defineMessages } from 'react-intl'
import globalMessages from 'client/messages'

const messages = defineMessages({
  description: {
    id: 'global.description',
  },
  descriptionAccommodation: {
    id: 'global.description-accommodation',
  },
  amenities: {
    id: 'global.amenities',
  },
  dining: {
    id: 'global.dining',
  },
  businessAmenities: {
    id: 'global.business-amenities',
  },
  attractions: {
    id: 'global.attractions',
  },
  renovations: {
    id: 'global.renovations',
  },
  activity: {
    id: 'global.activity',
  },
  rooms: {
    id: 'global.rooms',
  },
  pool: {
    id: 'global.pool',
  },
  additional: {
    id: 'global.additional-information',
  },
  location: {
    id: 'global.location',
  },
})

export default { ...globalMessages, ...messages }
